import { Link } from 'react-router-dom';

import { BrandMark } from './BrandMark';
import { PixelLink } from './PixelButton';

export const TopBar = () => (
  <header className="topbar">
    <div className="container topbar__inner">
      <Link to="/" className="brand" aria-label="Prepzio home">
        <BrandMark />
        <span className="brand__name">Prepzio</span>
        <span className="beta-pill" aria-label="Private beta">
          <span aria-hidden="true">●</span> Private beta
        </span>
      </Link>

      <nav aria-label="Primary" className="topbar__nav">
        <Link to="/blog" className="topbar__link">
          Blog
        </Link>
        {/* PRE-131: absolute /#waitlist so the CTA works from blog/legal pages too */}
        <PixelLink href="/#waitlist" size="sm">
          Join waitlist
        </PixelLink>
      </nav>
    </div>
  </header>
);
